export default "__VITE_ASSET__BrEz62xm__ 100w";